/**
 * @name 徕卡学院 
 * 
 */
import request from '@/common/ajax'

const api = {
  /**
   * 
   * @param {*} url 
   * @param {*} data 
   */
  //课程列表
  listCurriculum(data, url = `api/course/list`) {
    return request(url, data, 'GET');
  },
  /**
  * 
  * @param {*} url 
  * @param {*} data 
  */
  //课程详情接口
  detailCurriculum(data, url = `api/course/detail`) {
    return request(url, data, 'GET');
  },
  /**
  * 
  * @param {*} url 
  * @param {*} data 
  */
  //取消课程接口
  cancelCurriculum(data, url = `api/course/cancel`) {
    let {
      salesId,//销售用户id
      ourseId,//课程id
      courseName,//课程名称
      courseType,//课程类型
      teacherId,//培训导师
      rangeTime,//课程日期范围
      country,//国家
      city,//城市
      address,//地点
      studentType,//学员类型
      studentCnt,//学员人数
      currency,//币种
      price,//单人费用
      amount,//费用合计
      neededShow,//提交作品
      descption	//课程介绍
    } = data
    return request(url, data, 'GET');
  },
  /**
  * 
  * @param {*} url 
  * @param {*} data 
  */
  //课程新增//编辑保存接口
  addCurriculum(data, url = `api/course/save`) {
    return request(url, data, 'get');
  },
  /**
  * 
  * @param {*} url 
  * @param {*} data 
  */
  //课程日历视图接口
  calendarCurriculum(data, url = `api/course/view`) {
    return request(url, data, 'put');
  },
  //查询国家
  findContuny(data, url = `api/common/contuny`) {
    return request(url, data, 'get');
  },
  //根据上级区域ID查询区域列表
  findcity(data, url = `api/common/locals`) {
    return request(url, data, 'get');
  },
}

export default api





// WEBPACK FOOTER //
// ./src/api/lkcollege_api.js